export default __webpack_public_path__ + "static/media/newspaper_menu.3735cf3b.svg";